import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "27",
  viewBox: "0 0 26 27",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12.8613",
      cy: "13.3606",
      r: "11.8608",
      stroke: "#C2C3C8",
      "stroke-width": "2",
      "stroke-dasharray": "4 4"
    }, null, -1)
  ]))]))
}
export default { render: render }